*,
:host {
    box-sizing: border-box;
}

:host {
    grid-area: sidebar;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: var(--layout-body-top);
    width: 260px;
    bottom: var(--layout-site-bottom);
    overflow-x: hidden;
    overflow-y: auto;
    border-right: 4px solid var(--color-shade-20);
    background-color: var(--color-background);
}

aside {
    padding: 0;
    padding-top: 32px;
    padding-bottom: 10px;
}
